module.exports = __webpack_public_path__ + "img/partner-hover-1.354a94bc.png";